import { useAuth } from "../context/auth-context"

export const PrivilegedButton = ({ children, code }) => {
  const { user } = useAuth()
  const permissions = user?.user.permissions
  return <>
    {permissions.includes('*:*:*') || permissions.includes(code) ? children : null}
  </>
}
